var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    { staticClass: "form", on: { submit: _vm.handleSubmit } },
    [
      _c("FormControlDynamicSector", {
        attrs: {
          label: _vm.label,
          name: "sectors",
          options: _vm.dropdownOptions,
          "default-items": _vm.defaultItems,
          "include-parent-sector": false,
          "parent-sector-id": _vm.defaultSectorId,
        },
        on: { input: _vm.handleSectorChange },
        model: {
          value: _vm.selectedSector,
          callback: function ($$v) {
            _vm.selectedSector = $$v
          },
          expression: "selectedSector",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }